import {useField} from 'formik';
import {filter} from 'lodash';
import {useCallback} from 'react';

import {MultiInput, MultiInputProps, MultiInputChildren} from './MutliInput';

type Props = {
    name: string;
    values: any;
    itemsPath: string;
    children: MultiInputChildren;
} & Partial<MultiInputProps>;

export const MultiInputFormik: React.FC<Props> = ({name, values, itemsPath, ...rest}: Props) => {
    const [field,, helpers] = useField(name);

    const onRemove = useCallback(({index}) => {
        helpers.setValue(filter(field.value, (item, i) => i !== index));
    }, [field, helpers]);

    const onAdd = useCallback((item: any) => {
        helpers.setValue([...field.value, item]);
    }, [field, helpers]);

    return (
        <MultiInput {...rest} values={values} itemsPath={itemsPath} onAdd={onAdd} onRemove={onRemove} />
    );
};
